import { FooterMark } from "@/components/landing/FooterMark";

const SAMPLES = [
  ["A", "faint", false, "Faint, blended into black · no haze"],
  ["B", "faint", true, "Faint, blended · subtle purple/lime haze"],
  ["C", "solid", false, "Solid off-white · high contrast (TradingView-like)"],
  ["D", "dot", true, "Faint · lime final dot · subtle haze"],
];

export default function FooterLab() {
  return (
    <div data-testid="footer-lab-page" className="min-h-screen bg-[#0A0A0A] py-6">
      {SAMPLES.map(([k, tone, haze, note]) => (
        <section key={k} data-testid={`footer-sample-${k}`} className="mb-6 overflow-hidden border-y border-white/[0.07] bg-[#08090B]">
          <div className="mx-auto max-w-[1400px] px-6 pb-8 pt-10 md:px-12">
            <p className="inline-block border border-[#FFB224]/40 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] text-[#FFB224]">Option {k} · {note}</p>
            <div className="mt-8 flex justify-between border-t border-white/[0.07] pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5A6170]">
              <span>© 2026 TradrQuant · Quantify the market · Capture the edge</span><span className="hidden sm:inline">This isn't financial advice</span>
            </div>
            <FooterMark tone={tone} haze={haze} id={k} />
          </div>
        </section>
      ))}
    </div>
  );
}
